import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'routeSchedule',
    initialState: {
        isRequesting: false,
        error: null,
        isDone: false,
        data: null,
    },
    reducers: {
        update_route_schedule: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        update_route_schedule_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null,
            };
        },
        update_route_schedule_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        get_schedule: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        get_schedule_success: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: null,
                data: action.payload?.data || null,
            };
        },
        get_schedule_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null,
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
